var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "update-ticimax-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper d-none" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.channelName")))]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { placeholder: "Channel Name", name: "channelName" },
                model: {
                  value: _vm.clone.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "name", $$v)
                  },
                  expression: "clone.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("ticimax.xmlOrderListURL")))]),
              _vm._v(" "),
              _c("a-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  placeholder: _vm.$t("ticimax.xmlOrderListURL"),
                  name: "apiKey",
                },
                model: {
                  value: _vm.clone.payload.url,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.payload, "url", $$v)
                  },
                  expression: "clone.payload.url",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("wp.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("billing.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }